<template>
    <div class="about page-content" style="min-height: calc(100vh - 330px);">
        <script data-n-head="true" type="application/ld+json">{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                {
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://GameEnable.com/account",
                    "name": "Account"
                }
            ]
        }</script>
        <v-progress-circular
                v-if="loading"
                style="position: absolute; left: 0; right: 0; top: -260px; bottom: 0; margin: auto;"
                :size="70"
                :width="7"
                color="pink"
                indeterminate
        ></v-progress-circular>
        <span v-if="!loading">

             <v-card
                     class="mx-auto"
                     style="    margin: 25px 0;"
             >

            <v-card-subtitle class="pb-0"><p v-html="$t('account.subscriptionTitle')"></p></v-card-subtitle>

            <v-card-text class="text--primary">
                <div v-if="!subscription">
                    <v-progress-linear
                            color="pink"
                            indeterminate
                            reverse
                    ></v-progress-linear>
                </div>
                <div v-if="subscription !== false">
                    <div><b><span v-html="$t('account.statusTitle')"></span></b> : {{subscription.status}}<span
                            v-if="subscription.status === 'CANCELLED'"> - <small style='opacity:0.7'>(Active until the end of remaining purchase period)</small></span></div>
                    <div v-if="subscription.status !== 'none'"><b><span v-html="$t('account.typeTitle')"></span> </b> : {{subscription.description}} <small>({{subscription.paymentMethod}})</small></div>
                    <div v-if="subscription.status !== 'none'"><b><span v-html="$t('account.startedDateTitle')"></span></b> : {{(new Date(subscription.startDate * 1000)).toLocaleDateString()}}</div>

                </div>
            </v-card-text>

            <v-card-actions class="pull" v-if="subscription !== false">

                <v-chip
                        v-if="subscription.freeTrial && subscription.freeTrial.inFreeTrial"
                        class="ma-2"
                        color="primary"
                >
                    <span v-html="$t('account.trialEndsIn')"></span><b style="display: inline-block;margin:0 5px;"> {{ subscription.freeTrial.daysLeft }} </b><span
                        v-html="$t('account.days')"></span>
                </v-chip>
                <v-spacer></v-spacer>
                 <v-btn
                         color="pink"
                         class="subscription-button"
                         v-if="subscription.status === 'none'"
                         @click="openPaymentDialog"
                         v-text="user.hadSubscription? $t('account.getSubscription') : $t('account.startFreeTrial')"
                 >
                    <span v-html="$t('account.startFreeTrial')"></span>
                </v-btn>
            </v-card-actions>
        </v-card>

            <v-card
                    class="mx-auto"
                    style="    margin: 25px 0;"
            >

                <v-card-text class="text--primary">


      <v-row
              class="mb-6"

              no-gutters
      >
          <v-col  sm="6" md="6" cols="12" >
              <v-card-subtitle class="pb-0"><span v-html="$t('account.gameenable_clients')"></span></v-card-subtitle>
    <v-col cols="12" style="padding-right: 20px;"
           class="pb-0"
           v-for="downloadInfo in proprietaryApps"
           :key="downloadInfo.icon">
                        <v-card

                                class="mx-auto"
                                style="display: inline-block;box-sizing:border-box;margin-bottom:5px;margin-right:1.5%!important;width:100%;"

                                outlined
                        >
                            <v-card-title class="headline mb-1 text-center"
                                          style="font-size:large; word-break: initial"><span style="padding-left:30px;padding-right:30px;" v-html="downloadInfo.title"> </span>
                                <v-icon v-if="downloadInfo.icon" class="text-action float-right rtl"
                                        :style="($vuetify.rtl? 'right:15px;' : 'left:15px;') + (downloadInfo.iconStyle || '') +  'position:absolute;'"
                                        v-text="downloadInfo.icon"></v-icon>
                                <img v-if="downloadInfo.svg"  :src="downloadInfo.svg" class="text-action float-right rtl"
                                     :style="($vuetify.rtl? 'right:15px;' : 'left:15px;') + (downloadInfo.iconStyle || '') + 'position:absolute;width:24px;'"/>
                            </v-card-title>
                             <v-card-text class="download-card-subtitle" style="padding-bottom: 10px;">
                                 {{downloadInfo.subtitle}}
                             </v-card-text>
                            <v-card-text class="download-button">


                                <a
                                        color=" darken-1"
                                        text
                                        class="text-center"
                                        :href="downloadInfo.link"
                                        @click="(()=>{ downloadInfo.buttonCallback && downloadInfo.buttonCallback() }) "
                                        target="_blank"
                                        style="width: 100%;display:block;text-decoration: none;"
                                >
                                    <span class="text-action" style="font-weight: 500;"><span
                                            v-html="downloadInfo.buttonText"></span></span>
                                </a>

                            </v-card-text>


                        </v-card>
    </v-col>
              </v-col>
            <v-col  sm="6" md="6" cols="12" >
                <v-card-subtitle class="pb-0"><span v-html="$t('account.additional_downloads')"></span></v-card-subtitle>
    <v-col cols="12" style="padding-right: 20px;"
           class="pb-0"
           v-for="downloadInfo in additionalApps"
           :key="downloadInfo.icon">
                        <v-card

                                class="mx-auto"
                                style="display: inline-block;box-sizing:border-box;margin-bottom:5px;margin-right:1.5%!important;width:100%;"

                                outlined
                        >
                            <v-card-title class="headline mb-1 text-center"
                                          style="font-size:large; word-break: initial"><span style="padding-left:30px;padding-right:30px;">{{downloadInfo.title}}</span>
                                <v-icon v-if="downloadInfo.icon" class="text-action float-right rtl"
                                        :style="($vuetify.rtl? 'right:15px;' : 'left:15px;') + 'position:absolute;'"
                                        v-text="downloadInfo.icon"></v-icon>
                                <img v-if="downloadInfo.svg" :src="downloadInfo.svg" class="text-action float-right rtl"
                                     :style="($vuetify.rtl? 'right:15px;' : 'left:15px;') + 'position:absolute;width:24px;'"/>
                            </v-card-title>
                             <v-card-text class="download-card-subtitle" style="height: 31px;">
                                 {{downloadInfo.subtitle}}
                             </v-card-text>
                            <v-card-text class="download-button" style="">


                                <a
                                        color=" darken-1"
                                        text
                                        class="text-center"
                                        :href="downloadInfo.link"
                                        @click="(()=>{ downloadInfo.buttonCallback && downloadInfo.buttonCallback() }) "
                                        target="_blank"
                                        style="width: 100%;display:block;text-decoration: none;"
                                >
                                    <span class="text-action" style="font-weight: 500;"><span
                                            v-html="downloadInfo.buttonText"></span></span>
                                </a>

                            </v-card-text>


                        </v-card>
    </v-col>
              </v-col>
      </v-row>


                </v-card-text>

                <v-card-actions>


                </v-card-actions>
            </v-card>

 <v-card
         class="mx-auto"
         style="    margin: 25px 0;"
 >

            <v-card-subtitle class="pb-0"><span v-html="$t('account.tutorials')"></span></v-card-subtitle>

                <v-card-text class="text--primary">

                    <v-col lg="4" md="4" sm="12" style="display: inline-block;">
                        <v-card
                                class="mx-auto"

                        >
                        <iframe height="200"
                                :src="'https://www.youtube.com/embed/' + videos.PlayDestiny2OnStadiaFromUnsupported"
                                style="width:100%" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>

                        <v-card-title>
                        <span v-html="$t('account.tutorials_1_Title')"></span>
                        </v-card-title>

                        <v-card-subtitle>
                         <span v-html="$t('account.tutorials_1_Description')"></span>
                        </v-card-subtitle>

                      </v-card>
</v-col>
 <v-col lg="4" md="4" sm="12" style="display: inline-block;">
                        <v-card
                                class="mx-auto"

                        >
                        <iframe height="200"
                                :src="'https://www.youtube.com/embed/uZq7XPPcUAU'"
                                style="width:100%" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></iframe>

                        <v-card-title>
                        <span v-html="$t('account.tutorials_2_Title')"></span>
                        </v-card-title>

                        <v-card-subtitle>
                         <span v-html="$t('account.tutorials_2_Description')"></span>
                        </v-card-subtitle>

                      </v-card>
</v-col>
                </v-card-text>

                <v-card-actions>


                </v-card-actions>
            </v-card>

            <v-card
                    class="mx-auto"
                    style="    margin: 25px 0;"
            >

                <v-card-subtitle class="pb-0"><span v-html="$t('account.support')"></span></v-card-subtitle>

                <v-card-text class="text--primary">

                    <div class="feedback-text"><span v-html="$t('account.questionsOrFeedback')"></span></div>


             <v-spacer></v-spacer>
         <Div style="    margin-top: -41px;" class="float-right rtl"> <v-btn href="mailto: gameenable.com@gmail.com"
                                                                             icon>
            <v-icon>mdi-email</v-icon>
          </v-btn>
          <v-btn icon target="_blank" href="https://twitter.com/enablegame">
            <v-icon>mdi-twitter</v-icon>
          </v-btn>
          <v-btn icon target="_blank" href="https://discord.gg/V6fv3Nx">
            <v-icon>mdi-discord</v-icon>
          </v-btn></Div>
                </v-card-text>


            </v-card>

            <v-card
                    class="mx-auto"
                    style="    margin: 25px 0;"

            >

                <v-card-subtitle class="pb-0"><span
                        v-html="$t('account.subscriptionTermination')"></span></v-card-subtitle>

                <v-card-text class="text--primary">

                    <v-spacer></v-spacer>
                    <v-btn
                            text
                            color="pink"
                            class="cancel-subscription-button"
                            @click="onCancelSubscription"
                            v-if="subscription.status !== 'none' && subscription.status != 'CANCELLED' && !this.fetching"
                    >
                        <span v-html="$t('account.cancelSubscription')"></span>
                    </v-btn>

                    <v-spacer></v-spacer>
                    <span class="cancel-subscription-button-no-subscription" v-if="subscription.status === 'none'"><span
                            v-html="$t('account.noSubscription')"></span></span>

                </v-card-text>

                <v-card-actions>


                </v-card-actions>
            </v-card>

            <v-card
                    class="mx-auto"
                    style="    margin: 25px 0;"
            >

            <v-card-subtitle class="pb-0"><span v-html="$t('account.signOut')"></span></v-card-subtitle>

            <v-card-text class="text--primary">

                <v-spacer></v-spacer>
                <v-btn
                        outlined
                        color="pink"
                        class="sign-out-button"

                        @click="signOut"

                >
                    <span v-html="$t('account.signOut')"></span>
                </v-btn>

            </v-card-text>

            <v-card-actions>


            </v-card-actions>
        </v-card>

        </span>

        <account-payment-dialog :hadSubscription="user.hadSubscription" @completed="paymentCompleted"
                                :sign-in-token="signInToken" v-model="paymentDialogOpen"></account-payment-dialog>
        <v-dialog
                v-if="!dismissedFreeTrialModal"
                v-model="freeTrialSubscriptionDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline text-center" style="display: block;"><span
                        v-html="$t('account.freeTrialModalTitle')"></span></v-card-title>

                <v-card-text>
                    <img style="max-width:100%;margin-top:-10px;" src="../assets/devices.png">
                    <v-list-item-content

                            v-for="subItem in [ {title: $t('account.freeTrialModal24hrs'), soon: false }, { title: $t('account.freeTrialModalAllSupportedDevices'), soon: false }, { title: $t('account.freeTrialModalConnectAnywhere'), soon: false }]"
                            :key="subItem.title"
                            style="max-height: 30px; display: block;padding:2px;font-size:14px;height:30px;">
                        <v-list-item-title class="text-left">
                            <v-icon class="text-action" v-if="!subItem.soon"
                                    v-text="subItem.soon? 'mdi-history' : 'mdi-check-circle'"></v-icon>
                            <v-chip v-if="subItem.soon" class="ma-2" small
                                    style="    margin-right: -7px!important;margin-bottom:0!important;margin-top:0!important;">
                                <span v-html="$t('account.freeTrialModalSoon')"></span></v-chip>
                            {{subItem.title}}
                        </v-list-item-title>
                    </v-list-item-content>
                    <div style="margin-top:30px;"></div>
                    <v-btn
                            color="pink"
                            block
                            style=" color:#fff;    background: linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%)!important;bottom: 0;     margin-bottom: 10px;"
                            @click="openPaymentDialog"

                    >
                        <span v-html="$t('account.freeTrialModalStartTrial')"></span>
                    </v-btn>

                    <v-btn
                            color="pink darken-1"
                            text
                            block
                            style="  margin-bottom: 10px;"
                            @click="closeFreeTrialDialog"


                    >
                        <span v-html="$t('account.freeTrialModalNoThanks')"></span>
                    </v-btn>
                    <v-card-subtitle style="padding-top: 0; font-weight: 400; padding-bottom: 0;"><span
                            v-html="$t('account.freeTrialModalTerms')"></span></v-card-subtitle>
                </v-card-text>


            </v-card>
        </v-dialog>

        <configure-d-n-s  v-model="configureDNSDialog"></configure-d-n-s>
        <unautorizedSubscription v-model="unauthorizedSubscriptionDialog"></unautorizedSubscription>
        <cancel-subscription v-model="cancelSubscriptionDialog"
                             @completed="cancelSubscriptionCompleted"></cancel-subscription>
        <end-free-trial v-model="endFreeTrialDialog"
                        @completed="cancelSubscriptionDialog = true,endFreeTrialDialog = false"></end-free-trial>

    </div>
</template>


<style>

    .beta-tag {
        display: inline;
        font-size: 10px;
        background: white;
        border-radius: 23px;
        border: 1px solid #ff1a86;
        padding: 2px 5px;
        color: #ff1a86;

    }

    .feedback-text {

        padding-right: 120px;

    }

    .rtl .feedback-text {
        padding-right: 0px;
        padding-left: 120px;
    }

    .download-button {

        word-break: initial; overflow: visible; text-overflow: initial; position: absolute; top: 6px; right: 0; width: auto;

    }

    .rtl .download-button {
        right: auto;
        left: 0;
    }

    .subscription-button {

        right: 14px;
        top: 0px;
        color: #fff !important;
        background: linear-gradient(90deg, rgba(255, 81, 82, 1) 0%, rgba(255, 55, 117, 1) 49%, rgba(254, 0, 148, 1) 100%) !important;
        bottom: 0;
        margin: auto;
        margin-bottom: 10px;

    }

    .rtl .subscription-button {
        right: auto;
        left: 14px;

    }

    .cancel-subscription-button {

        position: absolute;
        right: 14px;
        top: 19px;
        color: #fff !important;

    }

    .rtl .cancel-subscription-button {
        right: auto;
        left: 14px;

    }

    .cancel-subscription-button-no-subscription {

        float: right;
        margin-top: -13px;

    }

    .rtl .cancel-subscription-button-no-subscription {
        right: auto;
        float: left;

    }

    .sign-out-button {

        position: absolute;
        right: 14px;
        top: 19px;
        color: #fff !important;

    }

    .rtl .sign-out-button {
        right: auto;
        left: 14px;

    }

    .download-card-subtitle {
        word-break: initial;
        overflow: visible;
        text-overflow: initial;
        text-align: left;
        font-size: 12px;
        margin-top: -17px;
        padding-bottom: 0;
    }

    .rtl .download-card-subtitle {
        text-align: right;
    }


</style>

<script>


    import {mapGetters, mapState} from 'vuex'
    import config from '../config';

    import AccountPaymentDialog from '../dialogs/AccountPayment'
    import CancelSubscription from '../dialogs/cancelSubscription'
    import EndFreeTrial from '../dialogs/endFreeTrial'
    import UnautorizedSubscription from '../dialogs/unautorizedSubscription'
    import ConfigureDNS from '../dialogs/configureDNS'
    import Page from '../mixins/page'


    import i18n from '@/i18n';

    export default {
        name: 'Account',
        mixins: [Page],
        data() {

            return {
                loading: true,
                subscription: false,
                cancelSubscriptionDialog: false,
                endFreeTrialDialog: false,
                paymentDialogOpen: false,
                fetching: true,
                unauthorizedSubscriptionDialog: false,
                configureDNSDialog: false,
                dismissedFreeTrialModal: localStorage.dismissedFreeTrialModal,
            };

        },

        async created() {

            if (!this.signedIn) {

                this.$router.push({name: 'Home', params: {lang: this.$i18n.locale}});
                return;


            }

            this.onFocus = this.onFocus.bind(this);

            window.addEventListener('focus', this.onFocus);

            this.loading = false;

            this.fetchSubscription();

        },
        destroyed() {
            window.removeEventListener('focus', this.onFocus);
        },
        computed: {
            ...mapGetters([
                'videos'
            ]),
            ...mapState(['signedIn', 'signInToken', 'user', 'hadSubscription']),
            pageTitle() {
                return i18n.t('account.pageTitle');
            },
            pageDescription() {
                return i18n.t('account.pageDescription');
            },
            freeTrialSubscriptionDialog: {
                // getter
                get: function () {
                    return (!localStorage.dismissedFreeTrialModal || !this.dismissedFreeTrialModal) && !this.user.haveSubscription && !this.hadSubscription;
                },
                // setter
                set: function (newValue) {
                    localStorage.dismissedFreeTrialModal = newValue;
                }
            },
            additionalApps() {
                return [

                    {
                        title: "Stadia",
                        subtitle: i18n.t('account.stadiaAppSubtitle'),
                        svg: 'data:image/svg+xml;base64,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',
                        link: 'https://apkpure.com/stadia/com.google.stadia.android',
                        buttonText: i18n.t('account.download'),
                    },
                    {
                        title: "GamePass",
                        subtitle: i18n.t('account.gamepassAppSubtitle'),
                        svg: 'data:image/svg+xml;base64,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',
                        link: 'https://apkpure.com/xbox-game-pass/com.gamepass',
                        buttonText: i18n.t('account.download'),
                    }

                ]
            },
            proprietaryApps() {
                return [

                    {
                        title: "Chrome",
                        subtitle: i18n.t('account.chromeAppSubtitle', {browserName: 'Chrome'}),
                        icon: 'mdi-google-chrome',
                        link: 'https://chrome.google.com/webstore/detail/GameEnable/nbokdicbgbjogapngakgpbfgalomlnik',
                        buttonText: i18n.t('account.download'),
                    },
                    {
                        title: "Edge",
                        subtitle: i18n.t('account.chromeAppSubtitle', {browserName: 'Edge'}),
                        svg: 'data:image/svg+xml;base64,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',
                        link: 'https://chrome.google.com/webstore/detail/GameEnable/nbokdicbgbjogapngakgpbfgalomlnik',
                        buttonText: i18n.t('account.download'),
                    },
                    {
                        title: "Android / TV",
                        subtitle: i18n.t('account.stadiaAndroidAppSubtitle'),
                        icon: 'mdi-android',
                        link: 'https://play.google.com/store/apps/details?id=com.gameenable',
                        buttonText: i18n.t('account.download'),
                    },
                    {
                        title: "DNS / Router <div class='beta-tag'>Beta</div>",
                        subtitle: i18n.t('account.stadiaChromeCaseSubtitle'),
                        svg: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDBwdCIgaGVpZ2h0PSI1NDBwdCIgdmlld0JveD0iMCAwIDU0MCA1NDAiIHZlcnNpb249IjEuMSI+PGRlZnMgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48c3R5bGU+LmNscy0xe2ZpbGw6dXJsKCNsaW5lYXItZ3JhZGllbnQpO30uY2xzLTJ7ZmlsbDojZmZmO308L3N0eWxlPjxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iOC4xMiIgeTE9IjM3LjMiIHgyPSIzNy4zIiB5Mj0iOC4xMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZjNTE1MiIvPjxzdG9wIG9mZnNldD0iMC41IiBzdG9wLWNvbG9yPSIjZmYzNzc1Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmUwMDk0Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+DQoNCjxnIGlkPSIjMDAwMDAwZmIiPg0KPHBhdGggZmlsbD0iIzAwMDAwMCIgb3BhY2l0eT0iMS4wMCIgZD0iIE0gMjQyLjM5IDAuMDAgTCAyOTIuMjAgMC4wMCBDIDI5NS4wMyAyLjI5IDI5OC42NiA0LjU5IDI5OS4zOCA4LjQwIEMgMzAwLjQ5IDE5LjQ3IDMwMC4xNSAzMC42MiAzMDAuNTcgNDEuNzIgQyAzMDQuNjMgNDMuOTUgMzA5LjYwIDQ2LjQ5IDMxMC4yOSA1MS42MiBDIDMxMS42OSA2OC4wMSAzMTIuMDYgODQuNjkgMzA5LjgzIDEwMS4wMiBDIDMwOS4zNyAxMDcuNDIgMzA0LjUwIDExMi4xOSAyOTkuMjggMTE1LjIzIEMgMjkyLjg3IDExNy45MCAyODUuODUgMTE4LjExIDI3OS4wNSAxMTguNzIgQyAyNzguOTcgMTUwLjcyIDI3OC45MyAxODIuNzMgMjc5LjA3IDIxNC43MyBDIDMwMy4xNSAyMTcuMDcgMzI3LjE1IDIyMy40NSAzNDcuOTkgMjM2LjAxIEMgMzc3LjU3IDI1Mi45NiA0MDEuNTIgMjc5LjYzIDQxNS4xNSAzMTAuODggQyA0MzEuNDEgMzQ3LjQwIDQzMi43MiAzODkuOTkgNDE5LjY1IDQyNy42NyBDIDQwMy4zMCA0NzUuNjYgMzYyLjc2IDUxNC43OSAzMTMuOTQgNTI4Ljc5IEMgMjY3LjQzIDU0My41NSAyMTQuNTMgNTM0LjMzIDE3NC44OSA1MDYuMTIgQyAxMzEuODUgNDc1LjYzIDEwNC44OCA0MjMuMDIgMTA3LjI5IDM3MC4wNyBDIDEwOC40MCAzMjAuNDkgMTM0LjM0IDI3Mi4zNSAxNzUuMDYgMjQ0LjA4IEMgMTk4LjkwIDIyNi44MCAyMjcuNzEgMjE3LjA3IDI1Ni45NSAyMTQuNjAgQyAyNTcuMDQgMTgyLjU5IDI1Ny4wNSAxNTAuNTkgMjU2Ljk0IDExOC41OCBDIDI1MC4zNyAxMTcuODAgMjQzLjY4IDExNy41MiAyMzcuMzIgMTE1LjU5IEMgMjI5LjM1IDExMi4yNCAyMjQuNjggMTAzLjQ5IDIyNS4wNyA5NS4wNCBDIDIyNC42MiA4MC4yMCAyMjQuMjAgNjUuMjggMjI1LjYzIDUwLjQ5IEMgMjI3Ljg0IDQ2LjU1IDIzMi4yNyA0NC41MiAyMzUuMDUgNDEuMDQgQyAyMzYuMjIgMzEuNDAgMjM1Ljc4IDIxLjY3IDIzNi40NCAxMS45OSBDIDIzNS4zNiA2LjgxIDIzOS42NSAzLjU2IDI0Mi4zOSAwLjAwIE0gMjU3LjAxIDIwLjg5IEMgMjU2Ljk3IDI4LjI2IDI1Ni45NyAzNS42MiAyNTcuMDEgNDIuOTkgQyAyNjQuMzkgNDMuMDIgMjcxLjc4IDQzLjAyIDI3OS4xNyA0My4wMCBDIDI3OS4wMSAzNS43MCAyNzkuMzggMjguMzEgMjc4LjA2IDIxLjA5IEMgMjcxLjA0IDIwLjc2IDI2NC4wMiAyMC44NyAyNTcuMDEgMjAuODkgTSAyNDUuOTYgNjQuNjQgQyAyNDUuOTUgNzUuMDkgMjQ2LjAyIDg1LjU0IDI0Ni4wMCA5NS45OSBDIDI2MC4zMyA5Ni4wMyAyNzQuNjYgOTYuMDAgMjg5LjAwIDk2LjAwIEMgMjg5LjAwIDg1LjMzIDI4OS4wMSA3NC42NiAyODkuMDAgNjMuOTkgQyAyNzQuNjUgNjQuMDAgMjYwLjI5IDYzLjczIDI0NS45NiA2NC42NCBNIDI1NC40NSAyMzYuNTcgQyAyMjUuMzIgMjM4Ljg4IDE5Ny42MCAyNTEuNTYgMTc1LjUzIDI3MC41MCBDIDE0NC42MCAyOTcuODcgMTI2LjI1IDMzOS41OCAxMjkuMDMgMzgxLjAyIEMgMTMwLjA4IDQyNC4wOCAxNTMuMjggNDY1Ljk4IDE4OS4xMCA0ODkuODcgQyAyMjUuODIgNTE1LjY1IDI3NS40MCA1MjEuMjEgMzE3LjI0IDUwNS4zMCBDIDM1OC42MCA0ODkuNzEgMzkxLjUwIDQ1My40NyA0MDIuNTggNDEwLjYyIEMgNDE0LjcyIDM2NS4xNiA0MDIuMjYgMzEzLjYwIDM2OS4yOSAyNzkuNzEgQyAzNDAuNDkgMjQ4LjU2IDI5Ni43MyAyMzEuNzMgMjU0LjQ1IDIzNi41NyBaIiBjbGFzcz0iY2xzLTEiLz4NCjxwYXRoIGZpbGw9IiMwMDAwMDAiIG9wYWNpdHk9IjEuMDAiIGQ9IiBNIDI1NS40NCAyNzkuNTEgQyAyODcuNTggMjc0Ljg5IDMyMS4yMSAyODguMjQgMzQxLjgwIDMxMy4yMSBDIDM2NS41MyAzNDEuMDIgMzcxLjI5IDM4My4xNiAzNTQuOTggNDE2LjAwIEMgMzQwLjM5IDQ0OC4xMCAzMDYuNDMgNDcwLjg4IDI3MS4wMiA0NzEuMDIgQyAyMzcuMjkgNDczLjEwIDIwMy42MSA0NTQuNTkgMTg2LjExIDQyNS45MCBDIDE3Mi4zOSA0MDQuOTMgMTY4LjUyIDM3OC4xNiAxNzMuNzQgMzUzLjg3IEMgMTgxLjk0IDMxNS4zMCAyMTYuMTcgMjgzLjg3IDI1NS40NCAyNzkuNTEgTSAyMjAuOTkgMzE2LjE4IEMgMjI4LjAxIDMyOC44NCAyMzUuNTMgMzQxLjI0IDI0Mi45NSAzNTMuNjcgQyAyNDkuNDIgMzQ5LjE2IDI1NS43MSAzNDMuNTMgMjY0LjA4IDM0My4yNyBDIDI4Ny44NSAzNDIuMzIgMzExLjY3IDM0My41MCAzMzUuNDYgMzQyLjgxIEMgMzI3LjUwIDMyNS45NiAzMTIuOTUgMzEyLjI1IDI5NS42NyAzMDUuMzEgQyAyNzEuMTMgMjk1LjI4IDI0MS44MCAyOTkuOTkgMjIwLjk5IDMxNi4xOCBNIDE5My4wOCAzNzkuOTggQyAxOTQuMzYgNDA4LjE4IDIxMy40NiA0MzQuMDkgMjM5LjU4IDQ0NC40NCBDIDI0Ni44NyA0MzEuODkgMjU0LjQ3IDQxOS41MSAyNjEuMTEgNDA2LjYwIEMgMjU1LjM5IDQwNC4wMCAyNDkuNTEgNDAxLjQ3IDI0NC43OCAzOTcuMjUgQyAyNDEuMTYgMzkzLjA2IDIzOC4yMCAzODguMzggMjM1LjQwIDM4My42NCBDIDIyNS43NSAzNjYuNTIgMjE1LjY0IDM0OS42NyAyMDUuNjUgMzMyLjc2IEMgMTk2LjY5IDM0Ni42OSAxOTEuNzMgMzYzLjM1IDE5My4wOCAzNzkuOTggTSAyNjYuMzQgMzY0LjMyIEMgMjU4LjgyIDM2NS4xMCAyNTQuMTMgMzc0Ljg4IDI1OS4wMCAzODEuMDAgQyAyNjMuMTcgMzg4LjMyIDI3NS4yOCAzODYuNzQgMjc3Ljg1IDM3OC44NiBDIDI4MS4wNCAzNzEuNjcgMjc0LjA0IDM2Mi44NiAyNjYuMzQgMzY0LjMyIE0gMjk4Ljc3IDM2My45NCBDIDI5OS43MCAzNzEuNDggMzAwLjcxIDM3OS40MSAyOTcuNTQgMzg2LjYyIEMgMjg2LjIwIDQwOC4xMSAyNzIuNjQgNDI4LjM5IDI2MS42MSA0NTAuMDYgQyAyNzguNDkgNDUwLjM2IDI5Ni4xMyA0NDcuMDkgMzEwLjAyIDQzNy4wMCBDIDMzMy40OCA0MjEuMzcgMzQ2LjQ3IDM5MS45MiAzNDIuMjYgMzY0LjAxIEMgMzI3Ljc2IDM2My45NiAzMTMuMjYgMzY0LjAyIDI5OC43NyAzNjMuOTQgWiIgY2xhc3M9ImNscy0xIi8+DQo8L2c+DQo8L3N2Zz4=',
                        link: undefined,
                        buttonText: i18n.t('account.configure'),
                        buttonCallback: () => {

                            this.configureDNSDialog = true;

                        }
                    },
                    {
                        title: "iPhone / iPad <div class='beta-tag'>Beta</div>",
                        subtitle: i18n.t('account.stadiaIphoneSubtitle'),
                        svg: 'data:image/svg+xml;base64,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',
                        iconStyle: 'aspect-ratio: 1/1; margin-top: -10px;',
                        link: undefined,
                        buttonText: i18n.t('account.readHow'),
                        buttonCallback: () => {

                            location.href = `/${this.$i18n.locale}/article/how-to-access-stadia-from-unsupported-country-on-chrome-iphone-ipad-or-apple-tv`;

                        }
                    },

                ]
            }
        },
        methods: {
            onFocus() {

                if(this.fetching){
                    return;
                }

                this.signInToken && this.$store.dispatch('syncUser', this.signInToken);
                this.fetchSubscription({silent: true});
            },
            async signOut() {
                this.$store.dispatch('signOut');
            },

            onCancelSubscription() {

                if (this.subscription.freeTrial && this.subscription.freeTrial.inFreeTrial) {

                    this.endFreeTrialDialog = true;

                } else {

                    this.cancelSubscriptionDialog = true;

                }

            },

            async cancelSubscriptionCompleted() {

                this.$UAnalytics.unsubscribed();

                this.user.hadSubscription = true;
                localStorage.user = JSON.stringify(this.user);

                this.signInToken && this.$store.dispatch('syncUser', this.signInToken);

                this.fetchSubscription();

            },

            async fetchSubscription({silent} = {silent: false}) {

                this.fetching = silent ? false : true;

                this.subscription = silent ? this.subscription : false;
                const response = await fetch(`${config.serverURL}/account/getSubscription`, {
                    method: 'POST',
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({jwtToken: localStorage.signInToken})
                });

                this.subscription = await response.json();

                this.fetching = false;

            },
            paymentCompleted(payload) {

                if (payload.status === "ERROR") {

                    this.unauthorizedSubscriptionDialog = true;
                    return;
                }

                this.fetchSubscription();

            },
            closeFreeTrialDialog() {
                this.dismissedFreeTrialModal = true;
                this.freeTrialSubscriptionDialog = true;
                localStorage.dismissedFreeTrialModal = 1;
            },
            openPaymentDialog() {
                this.paymentDialogOpen = true;
                this.closeFreeTrialDialog();

                this.$UAnalytics.clickedGetSubscription();

            }
        },
        components: {
            AccountPaymentDialog,
            CancelSubscription,
            UnautorizedSubscription,
            EndFreeTrial,
            ConfigureDNS
        }
    };
</script>

